import type { themes } from '..';
import { hashTheme } from './hashTheme';

/**
 * A wrapper around `hashTheme` that is used at runtime.
 * This function is used to allow theme overriding in local development, since
 * the themes are not hashed in local development.
 */
export function hashThemeRunTime(theme: string): keyof typeof themes {
  // Note: Using import.meta.env here (not envConfig) for build-time obfuscation.
  // Vite will tree-shake the unhashed branch from production builds.
  if (import.meta.env.VITE_IS_TEST_ENVIRONMENT === 'true') {
    return theme as keyof typeof themes;
  }

  return hashTheme(theme) as keyof typeof themes;
}
